/**全局加载效果*/
import { Loading } from "element-ui";

let loadingCount = 0
let loadingDom
let loadingDomMap = {}
const startLoading = target => {
  return Loading.service({
    target: target,
    lock: true,
    //background: "transparent"
  });
}

const endLoading = () => {
  loadingDom.close();
}

export const showLoading = (target, isMulti = false) => {
  if (isMulti) {
    const currentLoadingDom = startLoading(target);
    loadingDomMap[target] = currentLoadingDom
    return;
  }
  if (loadingCount === 0) {
    loadingDom = startLoading(target);
  }
  loadingCount += 1;
}

export const hideLoading = removeLoadingDom => {
  if (removeLoadingDom) {
    loadingDomMap[removeLoadingDom].close();
    return;
  }
  if (loadingCount <= 0) {
    return;
  }
  loadingCount -= 1;
  if (loadingCount === 0) {
    endLoading();
  }
}